import { useAsync } from 'libs/uikit/lib';
import React, { memo, useRef } from 'react';
import { PortalOutlet } from 'services/web/react/src/NgPortal/NgPortalOutlet';

export const NgApp = memo(() => {
  const ref = useRef<HTMLDivElement>(null);

  useAsync(async () => {
    // @ts-ignore
    const module = await import('../../../src/OCS.Web/wwwroot/app/app');

    // @ts-ignore
    module.bootstrap(ref.current);

    return null;
  });

  return (
    <>
      <div
        ref={ref}
        ng-controller="AppRootController"
        ng-cloak=""
        className="angularjs-root page-header-fixed page-quick-sidebar-over-content"
      >
        <div id="top" ui-view="" />
      </div>
      <PortalOutlet />
    </>
  );
});
